import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button, Popconfirm, Space } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

import type { ColumnsType } from 'antd/es/table';
import type { IUnit } from './types';

import { routes } from '@/app/router/routes';

import { useUnitDelete } from './queries';

export const useColumns = (): ColumnsType<IUnit> => {
  const { t } = useTranslation();
  const { mutate: unitDelete } = useUnitDelete();

  return [
    {
      title: t('units.symbol'),
      dataIndex: 'symbol',
      key: 'symbol',
    },
    {
      title: t('units.namePL'),
      dataIndex: 'namePl',
      key: 'namePl',
    },
    {
      title: t('units.nameEN'),
      dataIndex: 'nameEn',
      key: 'nameEn',
    },
    {
      title: '',
      key: 'actions',
      align: 'center' as const,
      render: (text: IUnit) => (
        <Space>
          <Link to={routes.unitUpdate(text.id)}>
            <Button>
              <EditOutlined />
            </Button>
          </Link>
          <Popconfirm
            title={t('units.delete.title')}
            okText={t('units.delete.okText')}
            cancelText={t('units.delete.cancelText')}
            placement='left'
            onConfirm={() => unitDelete(text.id)}
          >
            <Button>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];
};
